import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock, isNonEmptyBlock } from '../../types/api/Block';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { DefaultAccordion } from '../../_lib/components/Accordion/DefaultAccordion';
import { AttributeGroupInfoBlock } from '../../_blocks/AttributeGroupInfo';
import { AttributeGroupPropertiesBlock } from '../../_blocks/AttributeGroupProperties';
import { mapContextBlock } from '../../_blocks/mapContextBlock';

type AttributeGroupInfoWidgetBlocks = AttributeGroupInfoBlock | AttributeGroupPropertiesBlock;

export type AttributeGroupInfoWidget = ContextWidget<AttributeGroupInfoWidgetBlocks, WidgetType.attributegroupinfo>;

export function AttributeGroupInfoWidget({ blocks, elementType, ...headerProps }: AttributeGroupInfoWidget) {
  const { t } = useSonTranslation('AttributeGroups');

  if (blocks.every(isEmptyBlock)) {
    return null;
  }

  const accordionData = blocks.filter(isNonEmptyBlock).map(block => ({
    key: block.uuid,
    id: `${block.elementType}-${block.uuid}`,
    category: t(block.elementType),
    props: block,
  }));

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.INFO_BOX} title={t('widgetTitle')}>
      {/* @ts-expect-error mapContextBlock expects ContextBlock but accordion props union includes lazy variants */}
      <DefaultAccordion data={accordionData}>{({ props }) => mapContextBlock(props)}</DefaultAccordion>
    </DefaultWidgetWithHeader>
  );
}
